module.exports = __webpack_public_path__ + "img/fstvideo.05fec2fd.png";